// ** React Imports
import { useState, useEffect, useRef, Fragment } from 'react'
import { Button, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap"
import CreateWorkorder from './CreateWorkorder'
import { useSelector } from "react-redux"
import { isUserLoggedIn } from '@utils'
import { useNavigate, useParams } from "react-router-dom"
import { Plus } from 'react-feather'

const NavbarCreate = () => {
  const stores = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn())?.isEmployee
  const { woId } = useParams()
  const navigate = useNavigate()

  const [open, setOpen] = useState(false)
  const container = useRef(null)
  const [catData, setCatData] = useState([])
  const [catValue, setCatValue] = useState(null)

  const [centeredModal, setCenteredModal] = useState(false)
  const [categoryId, setCategoryId] = useState(null)
  const [typeId, setTypeId] = useState(null)
  const [valid, setValid] = useState(false)

  const clsModel = (centeredModal) => {
    setCenteredModal(centeredModal)
  }

  useEffect(() => {
    if (stores.woCates && stores.woCates.length > 0) {
      const woCates = stores.woCates.length > 0 ? stores.woCates : []
      if (woCates.find(find => find.code === 'RLM')) {
        setCategoryId(woCates.find(find => find.code === 'RLM'))
        const woTypes = woCates.find(find => find.code === 'RLM').woTypes
        if (woTypes.find(find => find.code === 'ETN')) {
          setTypeId(woTypes.find(find => find.code === 'ETN'))
        }
      }
    }
  }, [stores.woCates, stores.woCates.length])

  useEffect(() => {
    if (isEmployee) {
      setCatData([{ value: 1, label: 'Work Order' }, { value: 2, label: 'RLM/IMO Subscription' }])
    } else {
      setCatData([{ value: 1, label: 'Work Order' }])
    }
  }, [])

  useEffect(() => {
    if (catValue === 1) {
      setCenteredModal(!centeredModal)
      setValid(false)
      setCatValue(null)
    } else if (catValue === 2) {
      if (isEmployee) {
        setValid(true)
        setCenteredModal(!centeredModal)
        setCatValue(null)
      } else {
        if (categoryId) {
          if (woId) {
            navigate('/pageRefresh')
            setTimeout(() => {
              navigate(`/${categoryId.code}/${typeId.code}/save`)
            }, 2000)
          } else {
            navigate(`/${categoryId.code}/${typeId.code}/save`)
          }
        }
        setCatValue(null)
        setValid(false)
      }
    }
  }, [catValue])


  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      // clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })

  const handleMouseEnter = () => {
    setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  return (
    <Fragment>
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item dropdown-create nav-dropdown-create" onMouseLeave={handleMouseLeave} style={{ paddingTop: 0, border: 0 }}>
        <DropdownToggle
          href="/"
          tag="a"
          className="nav-link dropdown-user-link d-block float-right"
          onClick={(e) => e.preventDefault()}
          onMouseEnter={handleMouseEnter}
        >
          <Button.Ripple color='primary'>
            <Plus size={14} className='' style={{ marginBottom: '3px' }} />
            <span className='align-middles mx-50'>Create</span>
          </Button.Ripple>
        </DropdownToggle>
        <DropdownMenu end className={open ? 'show dropdown-menu-create' : 'hide dropdown-menu-create'}>
          {catData.map((item, index) => {
            return (
              <DropdownItem key={index} onClick={() => {
                setOpen(!open)
                setCatValue(item.value)
              }}>
                <span className="align-middle">{item.label}</span>
              </DropdownItem>
            )
          })}
        </DropdownMenu>
      </UncontrolledDropdown>

      <div className='float-left mx-50 d-none'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div>
          <Button.Ripple color='primary' style={{ marginLeft: '35px', marginRight: '10px' }}>
            <span className='align-middles ms-25'>Create</span>
          </Button.Ripple>
          {open && (
            <div className="dropdown-wrapper-db" style={{ right: '110px', marginLeft: 0 }}>
              <ul className="dropdown-menu-db">
                {catData.map((item) => {
                  return (
                    <li
                      className={"dropdown-menu-db__item"}
                      key={item.value}
                      onClick={() => {
                        setOpen(!open)
                        setCatValue(item.value)
                      }}
                    >
                      {item.label}
                    </li>
                  )
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
      {centeredModal &&
        <CreateWorkorder centerModal={centeredModal} closeModel={clsModel} categoryId={categoryId} typeId={typeId} valid={valid} />
      }
    </Fragment>
  )
}

export default NavbarCreate